import abstractModel from '../../core/ShopModel';

const resource = 'retailers/orders';

const model = abstractModel(resource);

model.saveItem = async (order_id, params) => {
  const newResource = `${resource}/${order_id}/payment_transactions`;

  return model.save(params, { path: newResource });
};

export default model;
